import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitPublicRoute: InvariantJiraRoute = {
	name: 'software-form-submit-public',
	path: '/jira/software/form/:formUuid',
	exact: true,
};
